import axios from "axios";
import { getAuthHeaders } from "./auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

export interface ToolGroup {
  id: number;
  groupObjectId: string;
  groupName: string;
}

export async function getToolGroups(toolName: string): Promise<ToolGroup[]> {
  const resp = await axios.get(
    `${BASE_URL}/tools/${encodeURIComponent(toolName)}/groups`,
    { headers: getAuthHeaders() }
  );
  return resp.data.groups as ToolGroup[];
}

/**
 * Add a group to a tool's roster. The server validates the GUID against Graph
 * and auto-populates groupName from the directory display name.
 *
 * Throws axios errors on:
 *   400 — invalid GUID format or missing field
 *   404 — Entra group with that ID does not exist
 *   409 — group is already configured for this tool
 */
export async function addToolGroup(
  toolName: string,
  groupObjectId: string
): Promise<ToolGroup> {
  const resp = await axios.post(
    `${BASE_URL}/tools/${encodeURIComponent(toolName)}/groups`,
    { groupObjectId },
    { headers: getAuthHeaders() }
  );
  return resp.data as ToolGroup;
}

export async function deleteToolGroup(
  toolName: string,
  groupId: number
): Promise<void> {
  await axios.delete(
    `${BASE_URL}/tools/${encodeURIComponent(toolName)}/groups/${groupId}`,
    { headers: getAuthHeaders() }
  );
}
